import { CircularProgress, TextField, TextareaAutosize } from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import "./OrganisationInfomation.scss";
import Select from "react-select";
import MapsInput from "../common/MapsInput";
import { useOutletContext } from "react-router-dom";
import { fileTypeMatch, toastMessage } from "../../helper";
import { bulkUploadService } from "../../services/emissionService";
import {
  fetchCompany,
  updateSettingsInfoService,
} from "../../services/orgService";
const styles = () => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #D7DFE9",
    borderRadius: "8px",
    height: "3rem",
  },
  "&:hover": {
    ".MuiOutlinedInput-notchedOutline": {
      border: "2px solid #59CE90 !important",
    },
  },
  ".MuiInputBase-root": {
    backgroundColor: "white",
  },
});

const OrganisationInfomation = () => {
  const validateSettingsForm = () => {
    return companyData?.address?.addressLine1?.length > 0;
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState<any>({
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      cityCode: "",
      state: "",
      stateCode: "",
      country: "",
      countryCode: "",
    },
    logo: "",
    description: "",
    name: "",
    registration_id: "",
    email: "",
    organisationBoundary: "",
  });
  const handleAddressChange = (e: any) => {
    const newForm = { ...companyData };
    newForm.address.addressLine1 = e.target.value.addressLine;
    newForm.address.stateCode = e.target.value.stateCode;
    newForm.address.countryCode = e.target.value.countryCode;
    newForm.address.city = e.target.value.city;
    newForm.address.cityCode = e.target.value.cityCode || "";
    newForm.address.state = e.target.value.state;
    newForm.address.country = e.target.value.country;
    setCompanyData(newForm);
  };
  const handleLogoChange = (event: any) => {
    if (
      event.target.files.length > 0 &&
      fileTypeMatch("image/*", event.target.files[0].type, "Invalid file type")
    ) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      bulkUploadService(formData).then((res) => {
        setCompanyData({
          ...companyData,
          logo: res.data.Location,
        });
      });
    }
  };
  const handleClick = () => {
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  useEffect(() => {
    fetchCompany()
      .then((res: any) => {
        const data = res.data;
        const currCompanyData = {
          logo: res.data.logo,
          name: res.data.name,
          registration_id: res.data.registration_id,
          address: {
            addressLine1: res.data.address_line1,
            addressLine2: data.address_type,
            city: data.city,
            cityCode: data.city_code,
            state: data.state,
            stateCode: data.state_code,
            country: data.country,
            countryCode: data.country_code,
          },
          email: res.data.email,
          description: res.data.description,
          organisationBoundary: res.data.organisation_boundary,
        };
        setCompanyData({ ...currCompanyData });
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const handleSettingsSave = () => {
    setIsLoading(true);
    const reqData = {
      description: companyData?.description,
      logo: companyData.logo,
      address: {
        addressLine1: companyData.address.addressLine1,
        stateCode: companyData.address.stateCode,
        countryCode: companyData.address.countryCode,
        city: companyData.address.city,
        cityCode: companyData.address.cityCode,
        state: companyData.address.state,
        country: companyData.address.country,
      },
      id: JSON.parse(localStorage.getItem("company") || "").id,
      organisationBoundary: companyData?.organisationBoundary,
    };
    updateSettingsInfoService(reqData)
      .then((res: any) => {
        console.log(res);
        toastMessage("Data updated successfully", "success");
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <Fragment>
      <div className="pw-settings-main h-100v w-full overflow-y-auto">
        <div className="pw-all-fileds-settings w-full">
          <div className="flex justify-between ">
            <div>
              <div className="pw-company-name flex flex-col gap-y-3">
                <div className="pw-text-neutral-600 pw-font-14px">
                  Company name
                </div>
                <TextField
                  type="name"
                  disabled
                  variant="outlined"
                  placeholder="Company"
                  value={companyData.name}
                  size="small"
                  name="email"
                  className="pw-width-100 pw-font-14px pw-text-neutral-900 pw-input-field-settings pw-input-text"
                  sx={styles}
                />
              </div>
              <div className="pw-company-name flex flex-col gap-y-3 mt-10">
                <div className="pw-text-neutral-600 pw-font-14px">Email ID</div>
                <TextField
                  type="email"
                  disabled
                  variant="outlined"
                  placeholder="Email"
                  value={companyData.email}
                  size="small"
                  name="email"
                  className="pw-width-100 pw-font-14px pw-text-neutral-900 pw-input-field-settings pw-input-text"
                  sx={styles}
                />
              </div>
              <div className="pw-company-name flex flex-col gap-y-3 mt-10">
                <div className="pw-text-neutral-600 pw-font-14px">
                  Registration ID
                </div>
                <TextField
                  type="email"
                  variant="outlined"
                  disabled
                  placeholder="Registration"
                  value={companyData.registration_id}
                  size="small"
                  name="email"
                  className="pw-width-100 pw-font-14px pw-text-neutral-900 pw-input-field-settings pw-input-text"
                  sx={styles}
                />
              </div>
            </div>
            <div className="pw-right-div flex mr-20 flex-col justify-start mt-10 ">
              <input
                type="file"
                accept="image/*"
                id="pw-e2e-employee-image"
                hidden
                ref={inputRef}
                onChange={handleLogoChange}
              />

              <div
                style={{ width: "150px", height: "150px", marginRight: "20vh" }}
              >
                <img
                  style={{ objectFit: "cover", width: "100%", height: "100%" }}
                  src={
                    companyData?.logo
                      ? companyData?.logo
                      : "assets/images/camera.png"
                  }
                  alt=" "
                  className="pw-circ-image h-35v"
                  onClick={handleClick}
                />
              </div>
              <div className="text-neutral-600 flex items-center mt-3 ml-14">
                <p>Company logo</p>
              </div>
            </div>
          </div>

          <div
            style={{ width: "70%" }}
            className="pw-input-field-settings  flex flex-col gap-y-3 mt-10"
          >
            <div className="flex flex-row pw-form-field">
              <div className="pw-input-label pw-text">Address</div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <MapsInput
              defaultValue={companyData?.address}
              placeholder="Address"
              sx={styles}
              className="pw-width-100 pw-input-field-settings pw-input-text bg-white "
              value={companyData.address.addressLine1}
              onChange={handleAddressChange}
              formData={companyData}
              setFormData={setCompanyData}
            />
          </div>

          <div className="pw-company-name flex flex-col gap-y-3 mt-10">
            <div className="pw-text-neutral-600 pw-font-14px">
              Company Description
            </div>
            <TextField
              type="text"
              variant="outlined"
              placeholder="Add your company description"
              value={companyData?.description}
              size="small"
              name="description"
              onChange={(e) => {
                setCompanyData({ ...companyData, description: e.target.value });
              }}
              className="pw-width-100 pw-font-14px pw-text-neutral-900 w-full pw-input-text"
              sx={styles}
            />
          </div>
          <div className="pw-company-name flex flex-col gap-y-3 mt-10">
            <div className="pw-text-neutral-600 pw-font-14px">
              Organisation Boundary
            </div>
            <TextareaAutosize
              placeholder="Enter Organisation Boundary"
              className="pw-width-100  pw-address pw-font-14px pw-text-neutral-900 w-full pw-input-text mb-10"
              value={companyData?.organisationBoundary}
              name="organisationBoundary"
              onChange={(e) => {
                setCompanyData({
                  ...companyData,
                  organisationBoundary: e.target.value,
                });
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-footer w-full gap-6 p-2">
        <div className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold ">
          {/* <div className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold">
            Cancel
          </div> */}
          <button
            className={`pw-bunit-button-primary pw-bunit-button-next text-white  font-bold ${
              validateSettingsForm()
                ? isLoading
                  ? "text-black bg-neutral-300"
                  : "cursor-pointer bg-primary"
                : "text-black bg-neutral-300"
            }`}
            onClick={() => {
              validateSettingsForm() && !isLoading && handleSettingsSave();
            }}
            disabled={!validateSettingsForm()}
          >
            {isLoading ? (
              <div className="flex flex-row gap-2 p-2">
                <span>{"Saving up"}</span>
                <CircularProgress size={20} />
              </div>
            ) : (
              <span>{"Save"}</span>
            )}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default OrganisationInfomation;
